import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const GameConfigContext = createContext({
  gelistirmeConsole: false,
  loaded: false,
});

export const GameConfigProvider = ({ children }) => {
  const [gelistirmeConsole, setGelistirmeConsole] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadConfig = async () => {
      try {
        const res = await axios.get('/api/game-config');
        if (!cancelled && res.data?.success) {
          setGelistirmeConsole(Boolean(res.data.gelistirmeConsole));
        }
      } catch (err) {
        console.error('Game config load error:', err);
      } finally {
        if (!cancelled) {
          setLoaded(true);
        }
      }
    };

    loadConfig();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <GameConfigContext.Provider value={{ gelistirmeConsole, loaded }}>
      {children}
    </GameConfigContext.Provider>
  );
};

export const useGameConfig = () => useContext(GameConfigContext);
